import '../pages/news/news.less'
import '../pages/news/quill.snow.css'

import React from 'react'
import ReactDOM from 'react-dom/client'

import { NewsList, type NewsListProps } from '../pages/news'
// import { NewsDetail, type NewsDetailProps } from '../pages/news'
import { getInitData } from './public/getInitData'

const { routerName } = getInitData()
if (routerName === 'list') {
  const rootEl = document.getElementById('root')
  if (rootEl) {
    const props = getInitData<NewsListProps>()
    const root = ReactDOM.createRoot(rootEl)
    root.render(
      <React.StrictMode>
        <NewsList {...props} />
      </React.StrictMode>
    )
  }
}
// if (routerName === 'detail') {
//   const rootEl = document.getElementById('root')
//   if (rootEl) {
//     const root = ReactDOM.createRoot(rootEl)
//     const props = getInitData<NewsDetailProps>()
//     root.render(
//       <React.StrictMode>
//         <NewsDetail {...props} />
//       </React.StrictMode>
//     )
//   }
// }
